import React, {useEffect} from 'react'
import {Box, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {getCurrentLanguage} from "../../utils/Helpers";


const InfoPageSoilSealingLayout = () =>{
    const {t, i18n} = useTranslation()
    const dispatch = useAppDispatch();
    let key = getCurrentLanguage(i18n);
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/soil-sealing",
            type:"pageView"
        }))
    });
    return (
        <div>
            <Typography style={{textAlign:"center", fontWeight:"bold"}}  variant="h3" gutterBottom>
                {t('info_page.soil_sealing.title' as any)}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {t('info_page.soil_sealing.subtitle' as any)}
            </Typography>
            <Grid container >
                <Grid container item >
                    <Box
                        component="img"
                        alt="Soil Sealing 1"
                        src={require("../../assets/pages/info/"+key+"/soil_sealing.png")}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
export default InfoPageSoilSealingLayout
